module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_dog_EN.010fc549.png";